module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('section', {
    staticClass: "content-header",
    staticStyle: {
      "height": "50px"
    }
  }, [_c('h1', {
    staticStyle: {
      "float": "left",
      "padding-right": "10px"
    }
  }, [_vm._v(_vm._s(_vm.title))]), _vm._v(" "), _c('a', {
    staticClass: "btn-flat",
    staticStyle: {
      "margin-left": "10px",
      "font-size": "20px",
      "cursor": "pointer"
    },
    attrs: {
      "title": "Refresh Printer Data"
    }
  }, [_c('i', {
    class: ['fa fa-refresh', _vm.isRefresh ? 'fa-spin text-red' : ''],
    staticStyle: {
      "color": "#3c8dbc"
    },
    on: {
      "click": function($event) {
        return _vm.refreshPrinter()
      }
    }
  })]), _vm._v(" "), _c('va-button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isDeleted),
      expression: "isDeleted"
    }],
    staticClass: "pull-left",
    attrs: {
      "isBlock": false,
      "theme": "danger",
      "name": "Restore Printer",
      "align": "right"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.restorePrinter($event)
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "box-tools pull-right"
  }, [_c('span', [_vm._v("Last Update: ")]), _c('b', [_vm._v(_vm._s(_vm.lastUpdate))])])], 1), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "table-responsive"
  }, [_c('div', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_c('div', {
    staticClass: "col-lg-4 col-md-4 col-sm-12"
  }, [_c('va-box', {
    attrs: {
      "title": "Printer Information",
      "isBorder": true,
      "theme": "box-warning",
      "widgetType": "question",
      "tooltip": _vm.tooltip.printerInfo
    }
  }, [_c('div', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, _vm._l((_vm.printerInfo), function(item) {
    return _c('div', {
      staticClass: "col-sm-12",
      staticStyle: {
        "padding-bottom": "10px"
      }
    }, [_c('span', {
      staticClass: "description-text"
    }, [_vm._v(_vm._s(item.title))]), _vm._v(" "), _c('div', {
      staticClass: "description-block",
      staticStyle: {
        "background-color": "#eee",
        "padding": "5px",
        "margin": "0px",
        "height": "30px"
      }
    }, [_c('b', {
      staticClass: "text-right pull-right"
    }, [_vm._v(_vm._s(item.value))])])])
  }), 0)]), _vm._v(" "), _c('va-box', {
    attrs: {
      "title": "Customer Info",
      "isBorder": true,
      "theme": "box-warning",
      "widgetType": ""
    }
  }, [_c('div', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_c('form', {
    staticClass: "form-horizontal"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-4 control-label",
    staticStyle: {
      "text-align": "left"
    }
  }, [_vm._v("Customer Name")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-8"
  }, [_c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "readonly": "",
      "placeholder": "CustomerName"
    },
    domProps: {
      "value": _vm.name
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-4 control-label",
    staticStyle: {
      "text-align": "left"
    }
  }, [_vm._v("Email")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-8"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.email),
      expression: "email"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "email",
      "placeholder": "Email"
    },
    domProps: {
      "value": (_vm.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.email = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-4 control-label",
    staticStyle: {
      "text-align": "left"
    }
  }, [_vm._v("Phone")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-8"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.phone),
      expression: "phone"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Phone"
    },
    domProps: {
      "value": (_vm.phone)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.phone = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-4 control-label",
    staticStyle: {
      "text-align": "left"
    }
  }, [_vm._v("Customer Address")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-8"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.address),
      expression: "address"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Customer Address"
    },
    domProps: {
      "value": (_vm.address)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.address = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-4 control-label",
    staticStyle: {
      "text-align": "left"
    }
  }, [_vm._v("Customer City")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-8"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.city),
      expression: "city"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Customer City"
    },
    domProps: {
      "value": (_vm.city)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.city = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-4 control-label",
    staticStyle: {
      "text-align": "left"
    }
  }, [_vm._v("Contact Name")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-8"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.contact),
      expression: "contact"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "email",
      "placeholder": "Contact Name"
    },
    domProps: {
      "value": (_vm.contact)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.contact = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-4 control-label",
    staticStyle: {
      "text-align": "left"
    }
  }, [_vm._v("Site")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-8"
  }, [_c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "readonly": "",
      "placeholder": "Site"
    },
    domProps: {
      "value": _vm.site
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-4 control-label",
    staticStyle: {
      "text-align": "left"
    }
  }, [_vm._v("Host Name")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-8"
  }, [_c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "readonly": "",
      "placeholder": "HostName"
    },
    domProps: {
      "value": _vm.hostName
    }
  })])])])])])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-lg-4 col-md-4 col-sm-12"
  }, [_c('va-box', {
    attrs: {
      "title": "Printer Counters",
      "isBorder": true,
      "theme": "box-warning",
      "widgetType": "question",
      "tooltip": _vm.tooltip.printerCounters
    }
  }, [_c('div', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, _vm._l((_vm.printerCounters), function(item) {
    return _c('div', {
      staticClass: "col-sm-12",
      staticStyle: {
        "padding-bottom": "10px"
      }
    }, [_c('span', {
      staticClass: "description-text"
    }, [_vm._v(_vm._s(item.title))]), _vm._v(" "), _c('div', {
      staticClass: "description-block",
      staticStyle: {
        "background-color": "#eee",
        "padding": "5px",
        "margin": "0px",
        "height": "30px"
      }
    }, [_c('b', {
      staticClass: "text-right pull-right"
    }, [_vm._v(_vm._s(item.value))])])])
  }), 0)])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-lg-4 col-md-4 col-sm-12"
  }, [(_vm.showImage) ? _c('div', [_c('va-box', {
    attrs: {
      "title": "Printer Image",
      "isBorder": true,
      "theme": "box-warning",
      "widgetType": "question",
      "tooltip": _vm.tooltip.printerInfo,
      "imagesList": _vm.images
    },
    on: {
      "imageChanged": _vm.imageChanged
    }
  }, [_c('div', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_c('img', {
    ref: "printerImage",
    staticStyle: {
      "width": "100%",
      "min-height": "100px",
      "max-height": "500px"
    },
    attrs: {
      "src": _vm.printer.imgUrl
    }
  }), _vm._v(" "), _c('loading', {
    attrs: {
      "active": _vm.loadingImage,
      "is-full-page": _vm.isFullpage
    },
    on: {
      "update:active": function($event) {
        _vm.loadingImage = $event
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('i', {
    staticClass: "fa fa-spinner fa-spin"
  }), _vm._v(" "), _c('span', [_vm._v("Saving image...")])])])], 1) : _vm._e(), _vm._v(" "), _c('div', [_c('va-box', {
    attrs: {
      "title": "Printer Status",
      "isBorder": true,
      "theme": "box-warning",
      "widgetType": "question",
      "tooltip": _vm.tooltip.printerStatus
    }
  }, [_c('div', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, _vm._l((_vm.printerStatus), function(item) {
    return _c('div', {
      staticClass: "col-sm-12",
      staticStyle: {
        "padding-bottom": "10px"
      }
    }, [_c('span', {
      staticClass: "description-text"
    }, [_vm._v(_vm._s(item.title))]), _vm._v(" "), _c('div', {
      staticClass: "description-block",
      staticStyle: {
        "background-color": "#eee",
        "padding": "2px",
        "margin": "0px",
        "height": "30px"
      }
    }, [_c('b', {
      staticClass: "text-right pull-right"
    }, [_vm._v(_vm._s(item.value))])])])
  }), 0)])], 1), _vm._v(" "), _c('va-box', {
    attrs: {
      "title": "Printer Toners",
      "isBorder": true,
      "theme": "box-warning",
      "widgetType": "question",
      "tooltip": _vm.tooltip.printerToners
    }
  }, [_c('div', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, _vm._l((_vm.printerToners), function(item) {
    return _c('div', {
      staticClass: "col-sm-3"
    }, [_c('div', {
      staticClass: "description-block",
      staticStyle: {
        "padding": "5px",
        "height": "50px"
      }
    }, [_c('span', {
      staticClass: "col-sm-5 description-text text-left"
    }, [_vm._v(_vm._s(item.title))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', [_c('div', {
      staticClass: "progress-group",
      staticStyle: {
        "width": "80px"
      }
    }, [_c('div', {
      staticClass: "progress sm",
      staticStyle: {
        "background-color": "#ccc",
        "height": "20px"
      }
    }, [(item.value >= 0) ? _c('div', {
      class: ['progress-bar', 'progress' + item.title],
      style: ({
        width: item.value + '%'
      })
    }, [_vm._v(_vm._s(item.value) + "%")]) : _c('div', [_vm._v("N/A")])])])])])])
  }), 0)]), _vm._v(" "), _c('va-box', {
    attrs: {
      "title": "Printer Properties",
      "isBorder": true,
      "theme": "box-warning",
      "widgetType": "question",
      "tooltip": _vm.tooltip.printerProps
    }
  }, [_c('div', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, _vm._l((_vm.printerProps), function(printerProp) {
    return _c('div', {
      staticClass: "col-sm-4",
      on: {
        "click": function($event) {
          printerProp.Value = !printerProp.Value
        }
      }
    }, [_c('div', {
      staticClass: "tree-content tree--small",
      staticStyle: {
        "float": "left!important"
      }
    }, [_c('i', {
      class: ['tree-checkbox', printerProp.Value ? 'checked' : '']
    }), _vm._v(" "), _c('span', {
      staticClass: "tree-anchor",
      attrs: {
        "tabindex": "-1"
      }
    }, [_c('span', {
      staticClass: "tree-text",
      staticStyle: {
        "white-space": "nowrap"
      }
    }, [_vm._v(_vm._s(printerProp.Key))])])])])
  }), 0)])], 1), _vm._v(" "), (0 > 1) ? _c('div', {
    staticClass: "col-lg-12 col-md-12 col-sm-12"
  }, [_c('va-box', {
    attrs: {
      "title": "Printer History (last 10 records)",
      "isBorder": true,
      "theme": "box-warning",
      "widgetType": "question",
      "tooltip": _vm.tooltip.printerInfo
    }
  }, [_c('div', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_c('VueTable', {
    attrs: {
      "columns": _vm.columns,
      "rows": _vm.printerHistory,
      "pageSize": 100
    }
  }), _vm._v(" "), _c('loading', {
    attrs: {
      "active": _vm.loadingPrinter,
      "is-full-page": _vm.isFullpage
    },
    on: {
      "update:active": function($event) {
        _vm.loadingPrinter = $event
      }
    }
  })], 1)])], 1) : _vm._e()])]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('va-button', {
    attrs: {
      "isBlock": false,
      "theme": "danger",
      "name": "Cancel",
      "align": "right"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.cancelType($event)
      }
    }
  }), _vm._v(" "), _c('va-button', {
    staticStyle: {
      "margin-right": "10px"
    },
    attrs: {
      "isBlock": false,
      "theme": "success",
      "name": "Save",
      "align": "right"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.Save($event)
      }
    }
  })], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-0537917e!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Printer.vue
// module id = 665
// module chunks = 0